const contrastedText = (backgroundColor: string) => {
  const cleanedBackgroundColor = backgroundColor.replace('#', '');
  const r = parseInt(cleanedBackgroundColor.substring(0, 2),16);
  const g = parseInt(cleanedBackgroundColor.substring(2, 4),16);
  const b = parseInt(cleanedBackgroundColor.substring(4, 6),16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq < 128);
}

export default contrastedText;
